import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, " LIBERAÇÃO DE USUÁRIOS PARA USAR AMBIENTE DE TESTE", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, " Alterações valerão para a proxima vez que o robor for executado. E isso ocorre todas as segundas e quintas feiras as 06:00 AM", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_6 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_7 = { class: "btn btn-outline-secondary" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_10 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_11 = { class: "table-responsive mb-4" }
const _hoisted_12 = { class: "table table-striped table-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Selecionar "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Login "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome ")
  ])
], -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}
const _hoisted_16 = { class: "row g-4" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_19 = { class: "btn btn-outline-secondary" }
const _hoisted_20 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_21 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_22 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_23 = { class: "table-responsive mb-4" }
const _hoisted_24 = { class: "table table-striped table-sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Selecionar "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Login "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome ")
  ])
], -1)
const _hoisted_26 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeListaUsers && $setup.storeListaUsers(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            class: "form-control",
            placeholder: "Procurar Nome ou Login ",
            onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: "user-plus" })
          ])
        ]),
        ($setup.data.msg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              ($setup.data.adduserok)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.data.msg), 1))
                : _createCommentVNode("", true),
              ($setup.data.errorAddUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.data.msg), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.nm_usuario
                }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.usersSel) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      value: user.nm_usuario
                    }, null, 8, _hoisted_14), [
                      [_vModelCheckbox, $setup.usersSel]
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(user.nm_usuario), 1),
                  _createElementVNode("td", null, _toDisplayString(user.ds_usuario), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ], 32),
      ($setup.page < $setup.lastPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary g-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_tabs, null, {
      default: _withCtx(() => [
        _createVNode(_component_tab, { title: "Usuarios Liberados" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.setListaUsers && $setup.setListaUsers(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", _hoisted_19, [
                    _createVNode(_component_font_awesome_icon, { icon: "user-minus" })
                  ])
                ]),
                ($setup.data.msg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      ($setup.data.adduserok)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true),
                      ($setup.data.errorAddUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.usersVincLista, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.nm_usuario
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.excSelUsers) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              value: user.nm_usuario
                            }, null, 8, _hoisted_26), [
                              [_vModelCheckbox, $setup.excSelUsers]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(user.nm_usuario), 1),
                          _createElementVNode("td", null, _toDisplayString(user.ds_usuario), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 32)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}